import axios from "axios";
import { useState, useContext, createContext, useEffect } from "react";

const CartContext = createContext();
const CartProvider = ({ children }) => {
const [cart, setCart] = useState([]);

  const getCartData = async(userId)=>{
    try {
          
          const country_data = sessionStorage.getItem("country_data");
          
          let {data} = await axios.get(`${process.env.REACT_APP_API_URL}/cart?customer_id=${userId}&country_code=${JSON.parse(country_data)?.country_code}`);
          
          if(data.length > 0){
           // console.log('userid', userId) 
           // console.log('API', data) 
            setCart(data);  
          }      
        } catch (error) {
          console.log(error)
        }
  }


  useEffect(() => {
    let existingCartItem = localStorage.getItem("cart");
    let auth =  JSON.parse(localStorage.getItem("auth"));
    let userId = auth?.user?.id;
   
    //console.log('local', JSON.parse(existingCartItem)) 
    if(userId){
      getCartData(userId);
    }else{
      
    if (existingCartItem) setCart(JSON.parse(existingCartItem));

    }
    
    //eslint-disable-next-line
  }, []);

  const updateCart = async (userId) => {
    const country_data = sessionStorage.getItem("country_data");
    let cart_data = await axios.get(`${process.env.REACT_APP_API_URL}/cart?customer_id=${userId}&country_code=${JSON.parse(country_data)?.country_code}`);
    setCart(cart_data.data)
  };
  


  return (
    <CartContext.Provider value={[cart, setCart,updateCart]}>
      {children}
    </CartContext.Provider>
  );
};

// custom hook
const useCart = () => useContext(CartContext);

export { useCart, CartProvider };